"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { GlobalStateProvider } from "./GlobalStateProvider";

const queryClient = new QueryClient();

const provider = ({ children }: PropsWithChildren) => {
	return (
		<QueryClientProvider client={queryClient}>
			<GlobalStateProvider>{children}</GlobalStateProvider>
		</QueryClientProvider>
	);
};

export default provider;
